import styled from "styled-components";

export const ContainerIllustrationEmptyList = styled.section`
  width: 100%;
  height: 500px;

  img {
    width: 100%;
    height: 100%;
  }
`;
